<div class="page-shell page-shell--canvas">

  <form [formGroup]="form" class="dc-wrapper">
    <div class="dc-header">
      <div class="dc-header__start">
        <mat-form-field appearance="outline" class="dc-name-field">
          <mat-label>{{ "digitalCards.displayName" | translate }}</mat-label>
          <input
            matInput
            formControlName="name"
            [placeholder]="'digitalCards.displayNamePlaceholder' | translate"
          />
        </mat-form-field>
      </div>
      <div class="dc-header__actions">
        <button mat-stroked-button type="button" (click)="back()">
          {{ "cancel" | translate }}
        </button>
        @if (showLayoutStart) {
          <button
            mat-stroked-button
            type="button"
            color="primary"
            [disabled]="!layoutApplied"
            (click)="enterCanvas()"
          >
            {{ "printCards.enterVisualEditor" | translate }}
          </button>
        } @else {
          <button
            mat-stroked-button
            type="button"
            color="primary"
            (click)="changeLayout()"
          >
            {{ "printCards.browseLayouts" | translate }}
          </button>
        }
        <button
          mat-raised-button
          type="button"
          color="primary"
          (click)="save()"
          [disabled]="!canSave || !pageReady"
        >
          @if (saving) {
            <mat-spinner diameter="20" class="dc-btn-spinner"></mat-spinner>
          } @else {
            <mat-icon class="dc-btn-icon">save</mat-icon>
          }
          {{ saving ? ("saving" | translate) : ("save" | translate) }}
        </button>
      </div>
    </div>
    @if (showLayoutStart) {
      <div class="dc-editor-grid">
        <div class="dc-section dc-preview-panel dc-preview-panel--editor">
          <div class="dc-section__content dc-preview-panel__body">
            <h3 class="dc-preview-panel__title">
              {{ "printCards.visualEditorPreview" | translate }}
            </h3>
            <div class="dc-preview-controls">
              @if (isPlasticNfcTemplate) {
                <mat-form-field appearance="outline" class="dc-preview-field">
                  <mat-label>{{ "printCards.pageSize" | translate }}</mat-label>
                  <input
                    matInput
                    [value]="
                      (orderPageSizePresets[0]?.labelKey ||
                        'printCards.pageSizePlastic85x54') | translate
                    "
                    readonly
                    tabindex="-1"
                  />
                </mat-form-field>
              } @else {
                <mat-form-field appearance="outline" class="dc-preview-field">
                  <mat-label>{{ "printCards.pageSize" | translate }}</mat-label>
                  <mat-select
                    formControlName="pageSizePreset"
                    (selectionChange)="onPageSizeChange($event.value)"
                  >
                    @for (preset of orderPageSizePresets; track preset.id) {
                      <mat-option [value]="preset.id">
                        {{ preset.labelKey | translate }}
                      </mat-option>
                    }
                  </mat-select>
                </mat-form-field>
              }
              <app-digital-card-employee-picker
                class="dc-preview-field"
                [value]="previewEmployee"
                (valueChange)="onPreviewEmployeeChange($event)"
                (initialSelectionResolved)="onEmployeePickerInitialResolved()"
              ></app-digital-card-employee-picker>
            </div>
            <div class="dc-preview-panel__stage">
              <app-print-card-preview
                [frontDocumentHtml]="previewFrontHtml"
                [backDocumentHtml]="previewBackHtml"
                [loading]="previewLoading"
                [pageWidthCm]="document.page.widthCm"
                [pageHeightCm]="document.page.heightCm"
              ></app-print-card-preview>
            </div>
          </div>
        </div>

        <div class="dc-section dc-form-panel">
          <div class="dc-section__content">
            <div class="dc-form">
              <section class="dc-block">
                <header class="dc-block__head">
                  <h3 class="dc-block__title">
                    {{ "printCards.templateTypeAndSizesTitle" | translate }}
                  </h3>
                </header>
                <div class="dc-block__body dc-fields-row">
                  <mat-form-field appearance="outline" class="dc-form-field-half">
                    <mat-label>{{
                      "printCards.templateTypeTitle" | translate
                    }}</mat-label>
                    <mat-select
                      formControlName="templateType"
                      (selectionChange)="onTemplateTypeChange($event.value)"
                    >
                      @for (type of templateTypes; track type) {
                        <mat-option [value]="type">
                          {{ ("printCards.templateType" + type) | translate }}
                        </mat-option>
                      }
                    </mat-select>
                  </mat-form-field>
                  <mat-form-field appearance="outline" class="dc-form-field-half">
                    <mat-label>{{
                      "printCards.orientationLabel" | translate
                    }}</mat-label>
                    <mat-select
                      formControlName="orientation"
                      (selectionChange)="onOrientationChange($event.value)"
                    >
                      @for (item of orientations; track item) {
                        <mat-option [value]="item">
                          {{ ("printCards.orientation." + item) | translate }}
                        </mat-option>
                      }
                    </mat-select>
                  </mat-form-field>
                  @if (!isPlasticNfcTemplate) {
                    <mat-form-field
                      appearance="outline"
                      class="dc-form-field-half"
                    >
                      <mat-label>{{
                        "printCards.allowedPageSizesLabel" | translate
                      }}</mat-label>
                      <mat-select
                        formControlName="allowedPageSizePresetIds"
                        multiple
                      >
                        @for (
                          preset of availablePageSizePresets;
                          track preset.id
                        ) {
                          <mat-option [value]="preset.id">
                            {{ preset.labelKey | translate }}
                          </mat-option>
                        }
                      </mat-select>
                    </mat-form-field>
                  }
                  <mat-form-field appearance="outline" class="dc-form-field-half">
                    <mat-label>{{
                      "printCards.allowedQuantitiesLabel" | translate
                    }}</mat-label>
                    <mat-select
                      formControlName="allowedQuantities"
                      multiple
                      [panelClass]="
                        isPlasticNfcTemplate ? 'pc-plastic-qty-panel' : null
                      "
                      (selectionChange)="stripPlasticQuantityAddSentinel()"
                    >
                      @for (quantity of availableQuantityOptions; track quantity) {
                        <mat-option [value]="quantity">
                          {{ quantity }}
                        </mat-option>
                      }
                      @if (isPlasticNfcTemplate) {
                        <mat-option
                          class="pc-plastic-qty-add-option"
                          [value]="plasticQuantityAddSentinel"
                          (onSelectionChange)="$event.stopPropagation()"
                        >
                          <div
                            class="pc-plastic-qty-panel__add"
                            (mousedown)="$event.preventDefault(); $event.stopPropagation()"
                            (click)="$event.preventDefault(); $event.stopPropagation()"
                            (keydown)="$event.stopPropagation()"
                          >
                            <mat-form-field
                              appearance="outline"
                              class="pc-plastic-qty-panel__field"
                              subscriptSizing="dynamic"
                            >
                              <mat-label>{{
                                "printCards.allowedQuantitiesAddLabel" | translate
                              }}</mat-label>
                              <input
                                matInput
                                type="number"
                                [min]="plasticQuantityMin"
                                [max]="plasticQuantityMax"
                                [(ngModel)]="plasticQuantityDraft"
                                [ngModelOptions]="{ standalone: true }"
                                (keydown.enter)="
                                  $event.preventDefault();
                                  addPlasticQuantityOption()
                                "
                              />
                            </mat-form-field>
                            <button
                              type="button"
                              mat-stroked-button
                              class="pc-plastic-qty-panel__btn"
                              [disabled]="!canAddPlasticQuantityOption"
                              (click)="addPlasticQuantityOption()"
                            >
                              {{ "printCards.allowedQuantitiesAdd" | translate }}
                            </button>
                          </div>
                        </mat-option>
                      }
                    </mat-select>
                  </mat-form-field>
                </div>
              </section>

              @if (hasPrinterOptions) {
                <section class="dc-block">
                  <header class="dc-block__head">
                    <h3 class="dc-block__title">
                      {{ "printCards.printerOptionsTitle" | translate }}
                    </h3>
                  </header>
                  <div class="dc-block__body dc-fields-row">
                    <mat-form-field
                      appearance="outline"
                      class="dc-form-field-half"
                    >
                      <mat-label>{{
                        (isPlasticNfcTemplate
                          ? "printCards.printerSubstrateLabel"
                          : "printCards.printerPaperLabel"
                        ) | translate
                      }}</mat-label>
                      <mat-select formControlName="printerPaperId">
                        @for (
                          option of printerSettings?.papers ?? [];
                          track option.id
                        ) {
                          <mat-option [value]="option.id">
                            {{ option.label }}
                          </mat-option>
                        }
                      </mat-select>
                    </mat-form-field>
                    <mat-form-field
                      appearance="outline"
                      class="dc-form-field-half"
                    >
                      <mat-label>{{
                        "printCards.printerPrintSidesLabel" | translate
                      }}</mat-label>
                      <mat-select formControlName="printSides">
                        @for (side of activePrintSidesOptions; track side) {
                          <mat-option [value]="side">
                            {{ printSidesLabelKey(side) | translate }}
                          </mat-option>
                        }
                      </mat-select>
                    </mat-form-field>
                    @if (isMultiloftPrinterOptions) {
                      <mat-form-field
                        appearance="outline"
                        class="dc-form-field-half"
                      >
                        <mat-label>{{
                          "printCards.printerSpacerColorLabel" | translate
                        }}</mat-label>
                        <mat-select formControlName="printerSpacerColorId">
                          @for (
                            option of printerSettings?.spacerColors ?? [];
                            track option.id
                          ) {
                            <mat-option [value]="option.id">
                              {{ option.label }}
                            </mat-option>
                          }
                        </mat-select>
                      </mat-form-field>
                    }
                  </div>
                </section>
              }

              <section class="dc-block">
                <header class="dc-block__head">
                  <h3 class="dc-block__title">
                    {{ "printCards.fontSectionTitle" | translate }}
                  </h3>
                </header>
                <div class="dc-block__body">
                  <mat-form-field appearance="outline" class="dc-form-field-full">
                    <mat-label>{{ "printCards.fontLabel" | translate }}</mat-label>
                    <mat-select
                      formControlName="fontPreset"
                      (selectionChange)="onFontChange($event.value)"
                    >
                      @for (font of fontPresets; track font.id) {
                        <mat-option [value]="font.id">
                          @if (font.label) {
                            {{ font.label }}
                          } @else if (font.labelKey) {
                            {{ font.labelKey | translate }}
                          }
                        </mat-option>
                      }
                    </mat-select>
                  </mat-form-field>
                  @if (!companyBrandFontReady) {
                    <p class="dc-font-upload-hint">
                      {{ "printCards.companyFontMissing" | translate
                      }}<a routerLink="/settings/company">{{
                        "printCards.companyFontSettingsLink" | translate
                      }}</a>
                    </p>
                  }
                </div>
              </section>

              <section class="dc-block">
                <header class="dc-block__head">
                  <h3 class="dc-block__title">
                    {{ "printCards.digitalCardForQr" | translate }}
                  </h3>
                </header>
                <div class="dc-block__body">
                  <app-searchable-select
                    class="dc-form-field-full"
                    formControlName="digitalCardProfileId"
                    [label]="'printCards.digitalCardForQr' | translate"
                    [options]="digitalCardTemplates"
                    [displayWith]="digitalCardTemplateLabel"
                    [valueWith]="digitalCardTemplateValue"
                    [emptyLabel]="'background.none' | translate"
                    [emptyValue]="null"
                    (valueChange)="onDigitalCardProfileIdChange($event)"
                  ></app-searchable-select>
                </div>
              </section>

              <section class="dc-block">
                <header class="dc-block__head">
                  <h3 class="dc-block__title">
                    {{ "printCards.layoutLabel" | translate }}
                  </h3>
                </header>
                <div class="dc-block__body">
                  <div class="pc-thumbs pc-thumbs--catalog">
                    @for (layout of layouts; track layout.key) {
                      <button
                        type="button"
                        class="pc-thumb"
                        [class.pc-thumb--active]="selectedLayoutKey === layout.key"
                        (click)="onLayoutSelect(layout.key)"
                      >
                        <span class="pc-thumb__preview" aria-hidden="true">
                          <app-print-card-layout-thumb
                            [documentHtml]="
                              layout.fronts[0]
                                ? layoutThumbHtml(
                                    layout.key,
                                    'front',
                                    layout.fronts[0].key
                                  )
                                : null
                            "
                            [pageWidthCm]="document.page.widthCm"
                            [pageHeightCm]="document.page.heightCm"
                            [loading]="loadingThumbs"
                          ></app-print-card-layout-thumb>
                        </span>
                        <span class="pc-thumb__label">{{ layout.name }}</span>
                      </button>
                    }
                  </div>
                  @if (!layouts.length) {
                    <p class="pc-empty">
                      {{ "printCards.layoutCatalogEmpty" | translate }}
                    </p>
                  }
                </div>
              </section>

              @if (selectedLayoutKey && isLayeredLayout) {
                <section class="dc-block">
                  <header class="dc-block__head">
                    <h3 class="dc-block__title">
                      {{ "printCards.layoutSidesSectionTitle" | translate }}
                    </h3>
                  </header>
                  <div class="dc-block__body pc-sides">
                    <div class="pc-sides__head">
                      <div class="pc-sides__col-title">
                        {{ "printCards.layoutFrontSectionTitle" | translate }}
                      </div>
                      <div class="pc-sides__col-title">
                        {{ "printCards.layoutBackSectionTitle" | translate }}
                      </div>
                    </div>

                    <div class="pc-sides__row">
                      <div class="pc-group">
                        <div class="pc-group__label">
                          {{ "printCards.layoutBrandSideLabel" | translate }}
                        </div>
                        @if (availableBrandSides.length) {
                          <div class="pc-thumbs">
                            @for (side of availableBrandSides; track side) {
                              <button
                                type="button"
                                class="pc-thumb"
                                [class.pc-thumb--active]="
                                  selectedBrandSide === side
                                "
                                (click)="onBrandSideSelect(side)"
                              >
                                <span class="pc-thumb__preview" aria-hidden="true">
                                  <app-print-card-layout-thumb
                                    [documentHtml]="
                                      layoutThumbHtml(
                                        selectedLayoutKey!,
                                        'front',
                                        side
                                      )
                                    "
                                    [pageWidthCm]="document.page.widthCm"
                                    [pageHeightCm]="document.page.heightCm"
                                    [loading]="loadingThumbs"
                                  ></app-print-card-layout-thumb>
                                </span>
                                <span class="pc-thumb__label">{{
                                  ("printCards.layoutBrandSide." + side)
                                    | translate
                                }}</span>
                              </button>
                            }
                          </div>
                        }
                      </div>
                      <div class="pc-group">
                        <div class="pc-group__label">
                          {{ "printCards.layoutBackStyleLabel" | translate }}
                        </div>
                        @if (availableBackStyles.length) {
                          <div class="pc-thumbs">
                            @for (style of availableBackStyles; track style) {
                              <button
                                type="button"
                                class="pc-thumb"
                                [class.pc-thumb--active]="
                                  selectedBackStyle === style
                                "
                                (click)="onBackStyleSelect(style)"
                              >
                                <span class="pc-thumb__preview" aria-hidden="true">
                                  <app-print-card-layout-thumb
                                    [documentHtml]="
                                      layoutThumbHtml(
                                        selectedLayoutKey!,
                                        'back',
                                        style
                                      )
                                    "
                                    [pageWidthCm]="document.page.widthCm"
                                    [pageHeightCm]="document.page.heightCm"
                                    [loading]="loadingThumbs"
                                  ></app-print-card-layout-thumb>
                                </span>
                                <span class="pc-thumb__label">{{
                                  ("printCards.layoutBackStyle." + style)
                                    | translate
                                }}</span>
                              </button>
                            }
                          </div>
                        }
                      </div>
                    </div>

                    <div class="pc-sides__row">
                      <div class="pc-group">
                        <div class="pc-group__label">
                          {{ "printCards.layoutFrontMarkerLabel" | translate }}
                        </div>
                        @if (availableFrontMarkers.length) {
                          <div class="pc-thumbs">
                            @for (marker of availableFrontMarkers; track marker) {
                              <button
                                type="button"
                                class="pc-thumb"
                                [class.pc-thumb--active]="
                                  selectedFrontMarker === marker
                                "
                                (click)="onFrontMarkerSelect(marker)"
                              >
                                <span class="pc-thumb__preview" aria-hidden="true">
                                  <app-print-card-layout-thumb
                                    [documentHtml]="
                                      layoutThumbHtml(
                                        selectedLayoutKey!,
                                        'front',
                                        marker === 'none'
                                          ? selectedBrandSide
                                          : selectedBrandSide + '-' + marker
                                      )
                                    "
                                    [pageWidthCm]="document.page.widthCm"
                                    [pageHeightCm]="document.page.heightCm"
                                    [loading]="loadingThumbs"
                                  ></app-print-card-layout-thumb>
                                </span>
                                <span class="pc-thumb__label">{{
                                  ("printCards.layoutMarker." + marker)
                                    | translate
                                }}</span>
                              </button>
                            }
                          </div>
                        }
                      </div>
                      <div class="pc-group">
                        <div class="pc-group__label">
                          {{ "printCards.layoutBackMarkerLabel" | translate }}
                        </div>
                        @if (availableBackMarkers.length) {
                          <div class="pc-thumbs">
                            @for (marker of availableBackMarkers; track marker) {
                              <button
                                type="button"
                                class="pc-thumb"
                                [class.pc-thumb--active]="
                                  selectedBackMarker === marker
                                "
                                (click)="onBackMarkerSelect(marker)"
                              >
                                <span class="pc-thumb__preview" aria-hidden="true">
                                  <app-print-card-layout-thumb
                                    [documentHtml]="
                                      layoutThumbHtml(
                                        selectedLayoutKey!,
                                        'back',
                                        marker === 'none'
                                          ? selectedBackStyle
                                          : selectedBackStyle + '-' + marker
                                      )
                                    "
                                    [pageWidthCm]="document.page.widthCm"
                                    [pageHeightCm]="document.page.heightCm"
                                    [loading]="loadingThumbs"
                                  ></app-print-card-layout-thumb>
                                </span>
                                <span class="pc-thumb__label">{{
                                  ("printCards.layoutMarker." + marker)
                                    | translate
                                }}</span>
                              </button>
                            }
                          </div>
                        }
                      </div>
                    </div>

                    <div class="pc-sides__row">
                      <div class="pc-group">
                        <div class="pc-group__label">
                          {{ "printCards.layoutColorsLabel" | translate }}
                        </div>
                        <div class="dc-color-grid">
                          <app-print-color
                            [label]="
                              'printCards.layoutTextColorLabel' | translate
                            "
                            [value]="frontTextColor"
                            (valueChange)="onFrontTextColorChange($event)"
                          ></app-print-color>
                          <app-print-color
                            [label]="
                              'printCards.layoutBackgroundLabel' | translate
                            "
                            [value]="frontBackgroundColor"
                            (valueChange)="onFrontBackgroundColorChange($event)"
                          ></app-print-color>
                          <app-print-color
                            [label]="'printCards.nfcColorLabel' | translate"
                            [value]="frontNfcColor"
                            (valueChange)="onFrontNfcColorChange($event)"
                          ></app-print-color>
                        </div>
                      </div>
                      <div class="pc-group">
                        <div class="pc-group__label">
                          {{ "printCards.layoutColorsLabel" | translate }}
                        </div>
                        <div class="dc-color-grid">
                          <app-print-color
                            [label]="
                              'printCards.layoutTextColorLabel' | translate
                            "
                            [value]="backTextColor"
                            (valueChange)="onBackTextColorChange($event)"
                          ></app-print-color>
                          <app-print-color
                            [label]="
                              'printCards.layoutBackgroundLabel' | translate
                            "
                            [value]="backBackgroundColor"
                            (valueChange)="onBackBackgroundColorChange($event)"
                          ></app-print-color>
                          <app-print-color
                            [label]="'printCards.nfcColorLabel' | translate"
                            [value]="backNfcColor"
                            (valueChange)="onBackNfcColorChange($event)"
                          ></app-print-color>
                        </div>
                      </div>
                    </div>

                    <div class="pc-sides__row">
                      <div class="pc-group">
                        <div class="pc-group__label">
                          {{ "printCards.backgroundImageLabel" | translate }}
                        </div>
                        <mat-form-field
                          appearance="outline"
                          class="dc-form-field-full dc-form-field-with-hint"
                        >
                          <mat-label>{{
                            "printCards.backgroundImageLabel" | translate
                          }}</mat-label>
                          <mat-select
                            [disabled]="mediaImagesLoading"
                            [value]="frontBackgroundImageUrl"
                            (selectionChange)="
                              setSideBackgroundImageUrl('front', $event.value)
                            "
                          >
                            <mat-select-trigger>
                              @if (frontBackgroundImageUrl) {
                                <span class="dc-logo-trigger">
                                  @if (
                                    mediaFilePreview(frontBackgroundImageUrl);
                                    as preview
                                  ) {
                                    <span
                                      class="dc-logo-trigger__file"
                                      aria-hidden="true"
                                    >
                                      <mat-icon>{{ preview.icon }}</mat-icon>
                                      <span>{{ preview.label }}</span>
                                    </span>
                                  } @else {
                                    <img
                                      [src]="frontBackgroundImageUrl"
                                      alt=""
                                      class="dc-logo-trigger__img"
                                      loading="lazy"
                                    />
                                  }
                                  {{
                                    backgroundImageLabel(
                                      frontBackgroundImageUrl
                                    )
                                  }}
                                </span>
                              } @else {
                                {{
                                  "printCards.backgroundImageNone" | translate
                                }}
                              }
                            </mat-select-trigger>
                            <mat-option value="">{{
                              "printCards.backgroundImageNone" | translate
                            }}</mat-option>
                            @if (orphanBackgroundImageUrl("front"); as orphan) {
                              <mat-option [value]="orphan">
                                <span class="dc-logo-option">
                                  @if (mediaFilePreview(orphan); as preview) {
                                    <span
                                      class="dc-logo-option__file"
                                      aria-hidden="true"
                                    >
                                      <mat-icon>{{ preview.icon }}</mat-icon>
                                      <span>{{ preview.label }}</span>
                                    </span>
                                  }
                                  <span>{{
                                    "printCards.backgroundImageStoredNotInMedia"
                                      | translate
                                  }}</span>
                                </span>
                              </mat-option>
                            }
                            @for (img of mediaImages; track img.imageId) {
                              <mat-option [value]="img.imageUrl">
                                <span class="dc-logo-option">
                                  @if (
                                    mediaFilePreview(img.imageUrl); as preview
                                  ) {
                                    <span
                                      class="dc-logo-option__file"
                                      aria-hidden="true"
                                    >
                                      <mat-icon>{{ preview.icon }}</mat-icon>
                                      <span>{{ preview.label }}</span>
                                    </span>
                                  } @else {
                                    <img
                                      [src]="img.imageUrl"
                                      alt=""
                                      class="dc-logo-option__img"
                                    />
                                  }
                                  <span>{{ img.name }}</span>
                                </span>
                              </mat-option>
                            }
                          </mat-select>
                          @if (!mediaImagesLoading && mediaImages.length === 0) {
                            <mat-hint>{{
                              "printCards.backgroundImageMediaEmptyHint"
                                | translate
                            }}</mat-hint>
                          }
                        </mat-form-field>
                      </div>
                      <div class="pc-group">
                        <div class="pc-group__label">
                          {{ "printCards.backgroundImageLabel" | translate }}
                        </div>
                        <mat-form-field
                          appearance="outline"
                          class="dc-form-field-full dc-form-field-with-hint"
                        >
                          <mat-label>{{
                            "printCards.backgroundImageLabel" | translate
                          }}</mat-label>
                          <mat-select
                            [disabled]="mediaImagesLoading"
                            [value]="backBackgroundImageUrl"
                            (selectionChange)="
                              setSideBackgroundImageUrl('back', $event.value)
                            "
                          >
                            <mat-select-trigger>
                              @if (backBackgroundImageUrl) {
                                <span class="dc-logo-trigger">
                                  @if (
                                    mediaFilePreview(backBackgroundImageUrl);
                                    as preview
                                  ) {
                                    <span
                                      class="dc-logo-trigger__file"
                                      aria-hidden="true"
                                    >
                                      <mat-icon>{{ preview.icon }}</mat-icon>
                                      <span>{{ preview.label }}</span>
                                    </span>
                                  } @else {
                                    <img
                                      [src]="backBackgroundImageUrl"
                                      alt=""
                                      class="dc-logo-trigger__img"
                                      loading="lazy"
                                    />
                                  }
                                  {{
                                    backgroundImageLabel(backBackgroundImageUrl)
                                  }}
                                </span>
                              } @else {
                                {{
                                  "printCards.backgroundImageNone" | translate
                                }}
                              }
                            </mat-select-trigger>
                            <mat-option value="">{{
                              "printCards.backgroundImageNone" | translate
                            }}</mat-option>
                            @if (orphanBackgroundImageUrl("back"); as orphan) {
                              <mat-option [value]="orphan">
                                <span class="dc-logo-option">
                                  @if (mediaFilePreview(orphan); as preview) {
                                    <span
                                      class="dc-logo-option__file"
                                      aria-hidden="true"
                                    >
                                      <mat-icon>{{ preview.icon }}</mat-icon>
                                      <span>{{ preview.label }}</span>
                                    </span>
                                  }
                                  <span>{{
                                    "printCards.backgroundImageStoredNotInMedia"
                                      | translate
                                  }}</span>
                                </span>
                              </mat-option>
                            }
                            @for (img of mediaImages; track img.imageId) {
                              <mat-option [value]="img.imageUrl">
                                <span class="dc-logo-option">
                                  @if (
                                    mediaFilePreview(img.imageUrl); as preview
                                  ) {
                                    <span
                                      class="dc-logo-option__file"
                                      aria-hidden="true"
                                    >
                                      <mat-icon>{{ preview.icon }}</mat-icon>
                                      <span>{{ preview.label }}</span>
                                    </span>
                                  } @else {
                                    <img
                                      [src]="img.imageUrl"
                                      alt=""
                                      class="dc-logo-option__img"
                                    />
                                  }
                                  <span>{{ img.name }}</span>
                                </span>
                              </mat-option>
                            }
                          </mat-select>
                          @if (!mediaImagesLoading && mediaImages.length === 0) {
                            <mat-hint>{{
                              "printCards.backgroundImageMediaEmptyHint"
                                | translate
                            }}</mat-hint>
                          }
                        </mat-form-field>
                      </div>
                    </div>
                  </div>
                </section>
              }
            </div>
          </div>
        </div>
      </div>
    } @else {
      <div class="pc-ve__workspace">
        <aside class="pc-ve__rail pc-ve__rail--left">
          <section
            class="pc-ve__panel pc-palette"
            [class.pc-ve__panel--collapsed]="!editorPanelOpen.elements"
          >
            <button
              type="button"
              class="pc-ve__panel-toggle"
              [attr.aria-expanded]="editorPanelOpen.elements"
              (click)="toggleEditorPanel('elements')"
            >
              <span class="pc-palette__title">
                {{ "printCards.elementsPaletteTitle" | translate }}
              </span>
              <mat-icon class="pc-ve__panel-chevron" aria-hidden="true">{{
                editorPanelOpen.elements ? "expand_less" : "expand_more"
              }}</mat-icon>
            </button>
            @if (editorPanelOpen.elements) {
              <div class="pc-ve__panel-body">
                @for (
                  group of paletteGroups;
                  track group.titleKey;
                  let last = $last
                ) {
                  <div class="pc-palette__group">
                    <h4 class="pc-palette__group-title">
                      {{ group.titleKey | translate }}
                    </h4>
                    <div class="pc-palette__grid">
                      @for (item of group.items; track item.labelKey) {
                        <button
                          type="button"
                          class="pc-palette__btn"
                          (click)="
                            onAddElement(
                              item.type,
                              item.variable,
                              item.pickDomainVariable === true
                            )
                          "
                        >
                          {{ item.labelKey | translate }}
                        </button>
                      }
                    </div>
                  </div>
                  @if (!last) {
                    <div class="pc-palette__divider" role="separator"></div>
                  }
                }
              </div>
            }
          </section>
          <section
            class="pc-ve__panel pc-layers"
            [class.pc-ve__panel--collapsed]="!editorPanelOpen.layers"
          >
            <button
              type="button"
              class="pc-ve__panel-toggle"
              [attr.aria-expanded]="editorPanelOpen.layers"
              (click)="toggleEditorPanel('layers')"
            >
              <span class="pc-layers__title">
                {{ "printCards.layersTitle" | translate }}
              </span>
              <mat-icon class="pc-ve__panel-chevron" aria-hidden="true">{{
                editorPanelOpen.layers ? "expand_less" : "expand_more"
              }}</mat-icon>
            </button>
            @if (editorPanelOpen.layers) {
              <div class="pc-ve__panel-body">
                @if (layerList.length === 0) {
                  <p class="pc-layers__empty">
                    {{ "printCards.layersEmpty" | translate }}
                  </p>
                } @else {
                  <ul
                    class="pc-layers__list"
                    cdkDropList
                    [cdkDropListData]="layerList"
                    (cdkDropListDropped)="onLayerDrop($event)"
                  >
                    @for (el of layerList; track el.id) {
                      <li
                        class="pc-layers__row"
                        cdkDrag
                        [cdkDragData]="el"
                        [class.pc-layers__row--active]="
                          selectedElementId === el.id
                        "
                      >
                        <button
                          type="button"
                          class="pc-layers__handle"
                          cdkDragHandle
                          [attr.aria-label]="elementLayerLabel(el)"
                        >
                          <mat-icon>drag_indicator</mat-icon>
                        </button>
                        <button
                          type="button"
                          class="pc-layers__item"
                          [class.pc-layers__item--active]="
                            selectedElementId === el.id
                          "
                          (click)="selectElement(el.id)"
                          (contextmenu)="onLayerListContextMenu($event, el.id)"
                        >
                          <span class="pc-layers__name">{{
                            elementLayerLabel(el)
                          }}</span>
                        </button>
                        <button
                          type="button"
                          class="pc-layers__delete"
                          [attr.aria-label]="'delete' | translate"
                          (click)="onDeleteLayerElement(el.id, $event)"
                        >
                          <mat-icon>delete</mat-icon>
                        </button>
                      </li>
                    }
                  </ul>
                }
              </div>
            }
          </section>
        </aside>

        <main class="pc-ve__stage">
          <div class="pc-ve__stage-edit">
            <div class="pc-ve__stage-bar">
              <div class="pc-ve__stage-heading">
                <h3 class="pc-ve__stage-title">
                  {{ "printCards.visualEditorCanvas" | translate }}
                </h3>
                <button
                  type="button"
                  class="pc-ve__help"
                  [matTooltip]="'printCards.editorShortcutsHint' | translate"
                  matTooltipClass="pc-ve-shortcuts-tooltip"
                  matTooltipPosition="below"
                  [attr.aria-label]="
                    'printCards.editorShortcutsButton' | translate
                  "
                >
                  <mat-icon>help_outline</mat-icon>
                </button>
              </div>
              <div class="pc-ve__tools">
                <div class="pc-ve__page-size-group">
                  <div class="pc-ve__tool-group" role="group">
                    <button
                      type="button"
                      class="pc-ve__tool"
                      (click)="onResetSizePositions()"
                      [matTooltip]="'printCards.resetSizePositions' | translate"
                      matTooltipPosition="below"
                      [attr.aria-label]="
                        'printCards.resetSizePositions' | translate
                      "
                    >
                      <mat-icon>restart_alt</mat-icon>
                    </button>
                  </div>
                  @if (!isPlasticNfcTemplate) {
                    <mat-form-field
                      appearance="outline"
                      class="pc-ve__field pc-ve__page-size-field"
                      floatLabel="always"
                      subscriptSizing="dynamic"
                    >
                      <mat-label>{{
                        "printCards.pageSize" | translate
                      }}</mat-label>
                      <mat-select
                        formControlName="pageSizePreset"
                        (selectionChange)="onPageSizeChange($event.value)"
                      >
                        @for (preset of orderPageSizePresets; track preset.id) {
                          <mat-option [value]="preset.id">
                            {{ preset.labelKey | translate }}
                          </mat-option>
                        }
                      </mat-select>
                    </mat-form-field>
                  }
                </div>
                <div class="pc-ve__tool-group" role="group">
                  <button
                    type="button"
                    class="pc-ve__tool"
                    (click)="undo()"
                    [disabled]="!canUndo()"
                    aria-label="Undo"
                  >
                    <mat-icon>undo</mat-icon>
                  </button>
                  <button
                    type="button"
                    class="pc-ve__tool"
                    (click)="redo()"
                    [disabled]="!canRedo()"
                    aria-label="Redo"
                  >
                    <mat-icon>redo</mat-icon>
                  </button>
                </div>
                <div class="pc-ve__tool-group" role="group">
                  <button
                    type="button"
                    class="pc-ve__tool"
                    (click)="setZoom(zoom - 0.1)"
                    aria-label="Zoom out"
                  >
                    <mat-icon>zoom_out</mat-icon>
                  </button>
                  <span class="pc-ve__zoom">{{
                    zoom * 100 | number: "1.0-0"
                  }}%</span>
                  <button
                    type="button"
                    class="pc-ve__tool"
                    (click)="setZoom(zoom + 0.1)"
                    aria-label="Zoom in"
                  >
                    <mat-icon>zoom_in</mat-icon>
                  </button>
                </div>
                <div class="pc-ve__side-toggle" role="group">
                  <button
                    type="button"
                    class="pc-ve__side"
                    [class.pc-ve__side--active]="activeSide === 'front'"
                    (click)="setActiveSide('front')"
                  >
                    {{ "printCards.tabFront" | translate }}
                  </button>
                  <button
                    type="button"
                    class="pc-ve__side"
                    [class.pc-ve__side--active]="activeSide === 'back'"
                    (click)="setActiveSide('back')"
                  >
                    {{ "printCards.tabBack" | translate }}
                  </button>
                </div>
              </div>
            </div>
            <app-print-card-canvas
              [page]="document.page"
              [side]="activeSideDesign"
              [cardSide]="activeSide"
              [selectedElementId]="selectedElementId"
              [zoom]="zoom"
              [fontFamily]="selectedFont.fontFamily"
              [fontCssUrl]="selectedFont.fontCssUrl"
              [companyFontFileUrl]="companyFontFileUrl"
              [sampleTexts]="canvasSampleTexts"
              [loading]="canvasLoading"
              [safeZoneInsetMm]="activeSafeZoneInsetMm"
              (canvasClick)="selectElement(null)"
              (zoomChange)="setZoom($event)"
              (selectElement)="selectElement($event)"
              (elementContextMenu)="onElementContextMenu($event)"
              (interactionStart)="beginInteraction()"
              (interactionEnd)="endInteraction()"
              (moveElement)="onMove($event)"
              (resizeElement)="onResize($event)"
              (rotateElement)="onRotate($event)"
            ></app-print-card-canvas>
          </div>
          <div class="dc-section dc-preview-panel dc-preview-panel--editor pc-ve__stage-preview">
            <div class="dc-section__content dc-preview-panel__body">
              <h3 class="dc-preview-panel__title">
                {{ "printCards.visualEditorPreview" | translate }}
              </h3>
              <div class="dc-preview-controls">
                <app-digital-card-employee-picker
                  class="dc-preview-field"
                  [value]="previewEmployee"
                  (valueChange)="onPreviewEmployeeChange($event)"
                  (initialSelectionResolved)="
                    onEmployeePickerInitialResolved()
                  "
                ></app-digital-card-employee-picker>
              </div>
              <div class="dc-preview-panel__stage">
                <app-print-card-preview
                  [frontDocumentHtml]="previewFrontHtml"
                  [backDocumentHtml]="previewBackHtml"
                  [loading]="previewLoading"
                  [pageWidthCm]="document.page.widthCm"
                  [pageHeightCm]="document.page.heightCm"
                ></app-print-card-preview>
              </div>
            </div>
          </div>
        </main>

        <aside class="pc-ve__rail pc-ve__rail--right">
          <section
            class="pc-ve__panel pc-ve__order-options"
            [class.pc-ve__panel--collapsed]="!editorPanelOpen.orderOptions"
          >
            <button
              type="button"
              class="pc-ve__panel-toggle"
              [attr.aria-expanded]="editorPanelOpen.orderOptions"
              (click)="toggleEditorPanel('orderOptions')"
            >
              <span class="pc-ve__panel-title">
                {{ "printCards.templateTypeAndSizesTitle" | translate }}
              </span>
              <mat-icon class="pc-ve__panel-chevron" aria-hidden="true">{{
                editorPanelOpen.orderOptions ? "expand_less" : "expand_more"
              }}</mat-icon>
            </button>
            @if (editorPanelOpen.orderOptions) {
              <div class="pc-ve__panel-body">
                <mat-form-field appearance="outline" class="pc-ve__field">
                  <mat-label>{{
                    "printCards.templateTypeTitle" | translate
                  }}</mat-label>
                  <mat-select
                    formControlName="templateType"
                    (selectionChange)="onTemplateTypeChange($event.value)"
                  >
                    @for (type of templateTypes; track type) {
                      <mat-option [value]="type">
                        {{ ("printCards.templateType" + type) | translate }}
                      </mat-option>
                    }
                  </mat-select>
                </mat-form-field>
                <mat-form-field appearance="outline" class="pc-ve__field">
                  <mat-label>{{
                    "printCards.orientationLabel" | translate
                  }}</mat-label>
                  <mat-select
                    formControlName="orientation"
                    (selectionChange)="onOrientationChange($event.value)"
                  >
                    @for (item of orientations; track item) {
                      <mat-option [value]="item">
                        {{ ("printCards.orientation." + item) | translate }}
                      </mat-option>
                    }
                  </mat-select>
                </mat-form-field>
                @if (!isPlasticNfcTemplate) {
                  <mat-form-field appearance="outline" class="pc-ve__field">
                    <mat-label>{{
                      "printCards.allowedPageSizesLabel" | translate
                    }}</mat-label>
                    <mat-select
                      formControlName="allowedPageSizePresetIds"
                      multiple
                    >
                      @for (
                        preset of availablePageSizePresets;
                        track preset.id
                      ) {
                        <mat-option [value]="preset.id">
                          {{ preset.labelKey | translate }}
                        </mat-option>
                      }
                    </mat-select>
                  </mat-form-field>
                }
                <mat-form-field appearance="outline" class="pc-ve__field">
                  <mat-label>{{
                    "printCards.allowedQuantitiesLabel" | translate
                  }}</mat-label>
                  <mat-select
                    formControlName="allowedQuantities"
                    multiple
                    [panelClass]="
                      isPlasticNfcTemplate ? 'pc-plastic-qty-panel' : null
                    "
                    (selectionChange)="stripPlasticQuantityAddSentinel()"
                  >
                    @for (quantity of availableQuantityOptions; track quantity) {
                      <mat-option [value]="quantity">
                        {{ quantity }}
                      </mat-option>
                    }
                    @if (isPlasticNfcTemplate) {
                      <mat-option
                        class="pc-plastic-qty-add-option"
                        [value]="plasticQuantityAddSentinel"
                        (onSelectionChange)="$event.stopPropagation()"
                      >
                        <div
                          class="pc-plastic-qty-panel__add"
                          (mousedown)="
                            $event.preventDefault(); $event.stopPropagation()
                          "
                          (click)="
                            $event.preventDefault(); $event.stopPropagation()
                          "
                          (keydown)="$event.stopPropagation()"
                        >
                          <mat-form-field
                            appearance="outline"
                            class="pc-plastic-qty-panel__field"
                            subscriptSizing="dynamic"
                          >
                            <mat-label>{{
                              "printCards.allowedQuantitiesAddLabel"
                                | translate
                            }}</mat-label>
                            <input
                              matInput
                              type="number"
                              [min]="plasticQuantityMin"
                              [max]="plasticQuantityMax"
                              [(ngModel)]="plasticQuantityDraft"
                              [ngModelOptions]="{ standalone: true }"
                              (keydown.enter)="
                                $event.preventDefault();
                                addPlasticQuantityOption()
                              "
                            />
                          </mat-form-field>
                          <button
                            type="button"
                            mat-stroked-button
                            class="pc-plastic-qty-panel__btn"
                            [disabled]="!canAddPlasticQuantityOption"
                            (click)="addPlasticQuantityOption()"
                          >
                            {{
                              "printCards.allowedQuantitiesAdd" | translate
                            }}
                          </button>
                        </div>
                      </mat-option>
                    }
                  </mat-select>
                </mat-form-field>
              </div>
            }
          </section>
          @if (hasPrinterOptions) {
            <section
              class="pc-ve__panel pc-ve__order-options"
              [class.pc-ve__panel--collapsed]="!editorPanelOpen.printerOptions"
            >
              <button
                type="button"
                class="pc-ve__panel-toggle"
                [attr.aria-expanded]="editorPanelOpen.printerOptions"
                (click)="toggleEditorPanel('printerOptions')"
              >
                <span class="pc-ve__panel-title">
                  {{ "printCards.printerOptionsTitle" | translate }}
                </span>
                <mat-icon class="pc-ve__panel-chevron" aria-hidden="true">{{
                  editorPanelOpen.printerOptions
                    ? "expand_less"
                    : "expand_more"
                }}</mat-icon>
              </button>
              @if (editorPanelOpen.printerOptions) {
                <div class="pc-ve__panel-body">
                  <mat-form-field appearance="outline" class="pc-ve__field">
                    <mat-label>{{
                      (isPlasticNfcTemplate
                        ? "printCards.printerSubstrateLabel"
                        : "printCards.printerPaperLabel"
                      ) | translate
                    }}</mat-label>
                    <mat-select formControlName="printerPaperId">
                      @for (
                        option of printerSettings?.papers ?? [];
                        track option.id
                      ) {
                        <mat-option [value]="option.id">
                          {{ option.label }}
                        </mat-option>
                      }
                    </mat-select>
                  </mat-form-field>
                  <mat-form-field appearance="outline" class="pc-ve__field">
                    <mat-label>{{
                      "printCards.printerPrintSidesLabel" | translate
                    }}</mat-label>
                    <mat-select formControlName="printSides">
                      @for (side of activePrintSidesOptions; track side) {
                        <mat-option [value]="side">
                          {{ printSidesLabelKey(side) | translate }}
                        </mat-option>
                      }
                    </mat-select>
                  </mat-form-field>
                  @if (isMultiloftPrinterOptions) {
                    <mat-form-field appearance="outline" class="pc-ve__field">
                      <mat-label>{{
                        "printCards.printerSpacerColorLabel" | translate
                      }}</mat-label>
                      <mat-select formControlName="printerSpacerColorId">
                        @for (
                          option of printerSettings?.spacerColors ?? [];
                          track option.id
                        ) {
                          <mat-option [value]="option.id">
                            {{ option.label }}
                          </mat-option>
                        }
                      </mat-select>
                    </mat-form-field>
                  }
                </div>
              }
            </section>
          }
          <app-print-card-properties-panel
            [element]="selectedElement"
            [activeSide]="activeSide"
            [backgroundColor]="activeSideDesign.backgroundColor"
            [backgroundImageUrl]="activeSideDesign.backgroundImageUrl ?? null"
            [mediaImages]="mediaImages"
            [mediaImagesLoading]="mediaImagesLoading"
            [fontPresets]="fontPresets"
            [fontPresetId]="selectedFontId"
            [companyBrandFontReady]="companyBrandFontReady"
            [digitalCardTemplates]="digitalCardTemplates"
            [digitalCardProfileId]="form.controls.digitalCardProfileId.value"
            [squashTargets]="squashTargetOptions"
            [domainVariables]="domainVariables"
            (patchElement)="onPatchElement($event)"
            (backgroundColorChange)="onBackgroundColorChange($event)"
            (backgroundImageUrlChange)="
              setSideBackgroundImageUrl(activeSide, $event)
            "
            (fontPresetChange)="onFontChange($event)"
            (digitalCardProfileIdChange)="onDigitalCardProfileIdChange($event)"
            (squashWithElement)="onSquashWithElement($event)"
            (unsquashElement)="onUnsquashElement()"
          ></app-print-card-properties-panel>
        </aside>
      </div>

      <div
        class="pc-ve__context-anchor"
        [style.left.px]="contextMenuPosition.x"
        [style.top.px]="contextMenuPosition.y"
        [matMenuTriggerFor]="elementContextMenu"
        #elementContextMenuTrigger="matMenuTrigger"
      ></div>
      <mat-menu #elementContextMenu="matMenu" class="pc-ve-context-menu">
        <button type="button" mat-menu-item (click)="onBringToFront()">
          <mat-icon>flip_to_front</mat-icon>
          <span>{{ "printCards.propertiesBringToFront" | translate }}</span>
        </button>
        <button type="button" mat-menu-item (click)="onSendToBack()">
          <mat-icon>flip_to_back</mat-icon>
          <span>{{ "printCards.propertiesSendToBack" | translate }}</span>
        </button>
        <button type="button" mat-menu-item (click)="onDuplicateElement()">
          <mat-icon>content_copy</mat-icon>
          <span>{{ "printCards.propertiesDuplicate" | translate }}</span>
        </button>
        <button
          type="button"
          mat-menu-item
          class="pc-ve-context-menu__danger"
          (click)="onDeleteElement()"
        >
          <mat-icon>delete</mat-icon>
          <span>{{ "delete" | translate }}</span>
        </button>
      </mat-menu>
    }
  </form>
@if (!pageReady) {
  <div class="dbc1-loading dbc1-loading--overlay">
    <app-loading></app-loading>
  </div>
}
</div>
